import { AlertCircle } from "lucide-react";

export default function NDAConsent({ checked, error, onChange, onOpenNDA }) {
    return (
        <div>
            <label className="flex items-start gap-3 cursor-pointer group">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="mt-1 w-4 h-4 accent-[#C9A86A] cursor-pointer shrink-0"
                    data-testid="private-access-nda"
                />
                <span className="text-[#C9C5BC] text-[13px] leading-[1.7]">
                    I agree to the terms of the{" "}
                    <button
                        type="button"
                        onClick={onOpenNDA}
                        className="text-[#C9A86A] hover:text-[#D9BC80] transition-colors duration-300 underline underline-offset-4 decoration-[rgba(201,168,106,0.3)]"
                        data-testid="private-access-read-nda"
                    >
                        Non-Disclosure Agreement
                    </button>{" "}
                    governing this material.
                </span>
            </label>
            {error && (
                <p className="mt-2 ml-7 flex items-center gap-2 text-[12px] text-[#C97A6A]">
                    <AlertCircle size={12} strokeWidth={1.6} />
                    {error}
                </p>
            )}
        </div>
    );
}
